module.exports = __webpack_public_path__ + "static/media/Maf_18Junio.5b1870bf.jpg";